var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteEditCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.60594 0 0 3.60594 0 8C0 12.3941 3.60594 16 8 16C12.3941 16 16 12.3941 16 8C16 3.60594 12.3941 0 8 0ZM7.03184 11.6388L3.52856 8.1355L4.85425 6.80981L7.09319 9.04875L11.588 4.96275L12.8496 6.34978L7.03184 11.6388Z",
    fill: "#3176BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteEditCompetitor);
export default __webpack_public_path__ + "static/media/Complete-Edit-Competitor.7cb31159af43d494a7b59bba031ab5cc.svg";
export { ForwardRef as ReactComponent };